import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { APP_LIVE, storeUrlFor } from "@/config/site";
import { getPlatform } from "@/lib/device";
import { scrollToId } from "@/lib/scroll";
import { useWaitlist } from "@/context/WaitlistContext";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ValueProp } from "@/components/site/ValueProp";
import { Features } from "@/components/site/Features";
import { AppShowcase } from "@/components/site/AppShowcase";
import { QRDownload } from "@/components/site/QRDownload";
import { ForArtists } from "@/components/site/ForArtists";
import { Global } from "@/components/site/Global";
import { Opportunities } from "@/components/site/Opportunities";
import { Pricing } from "@/components/site/Pricing";
import { Proof } from "@/components/site/Proof";
import { WhyPitchally } from "@/components/site/WhyPitchally";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";
import { CursorGlow } from "@/components/site/Glow";

// Handles QR / share deep links: ?join=waitlist, ?get=app and #section.
const useEntryIntent = () => {
  const { search, hash } = useLocation();
  const { openWaitlist } = useWaitlist();
  useEffect(() => {
    const params = new URLSearchParams(search);
    if (params.get("get") === "app" && APP_LIVE) {
      const url = storeUrlFor(getPlatform());
      if (url) window.location.replace(url);
      else setTimeout(() => scrollToId("download"), 400);
    } else if (params.get("join") === "waitlist" || params.get("get") === "app") {
      openWaitlist({ source: "qr" });
    } else if (hash) {
      setTimeout(() => scrollToId(hash.slice(1)), 400);
    }
  }, [search, hash, openWaitlist]);
};

export default function Landing() {
  useEntryIntent();
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-pa-orange focus:px-4 focus:py-2 focus:text-pa-black">
        Skip to content
      </a>
      <Navbar />
      <CursorGlow />
      <main id="main">
        <Hero />
        <Marquee />
        <ValueProp />
        <Features />
        <AppShowcase />
        <QRDownload />
        <ForArtists />
        <Global />
        <Opportunities />
        <Pricing />
        <Proof />
        <WhyPitchally />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
